import React from "react";
import TemplateAttachmentsView from "./TemplateAttachmentsView";
import { useTemplateAttachmentsController, TemplateAttachmentsControllerProps } from "../hooks/useTemplateAttachmentsController";

export default function TemplateAttachments(props: TemplateAttachmentsControllerProps) {
    const ctrl = useTemplateAttachmentsController(props);
    return <TemplateAttachmentsView {...ctrl} />;
}
